import React from 'react';
import { thankYouCheck } from '../../../images/images';
import ConsentStepper from './ConsentStepper';
import './ConsentStepper.css'

const ConsentStepperContainer = ({ handleContinueBtn, timeTaken, fileSize }) => {

    return (
        <div className='consent-stepper-cntnr' >
            <div className='custmr-details-consent' >
                <div className='vposv-que-details'>
                    <div className='vposv-que-details-1'>
                        <div className='vposv-que-name'>
                            <h4>Name</h4>
                            <p>
                                {localStorage.getItem("proposerFirstname")}
                            </p>
                        </div>
                        <div className='vposv-que-product'>
                            <h4>Product</h4>
                            <p>
                                {localStorage.getItem("productName")}
                            </p>
                        </div>
                    </div>
                    <div className='vposv-que-details-2'>
                        <div className='vposv-que-proposal'>
                            <h4>Policy no.</h4>
                            <p>
                                {localStorage.getItem("policyNumber")}
                            </p>
                        </div>
                        <div className='video-verify-container'>
                            <img className='cust-img' src={localStorage.getItem('custImg')} alt='' />
                            {/* <video
                                id='video-verify'
                                width="240"
                                height="240"
                                style={{ width: "240", height: "240" }}
                                preload={"auto"}
                                autoPlay
                                loop
                                muted
                            ></video> */}
                        </div>
                    </div>

                </div>

            </div>
            <div className='stp-cntnr' >
                <div className='done-img-icn' >
                    <img src={thankYouCheck} alt='' />
                    <p>Video Consent Verification is Successful</p>
                </div>
                <ConsentStepper currentStep={3} orientation={"vertical"} />
            </div>
            <div className='recording-btns ci-btn' >
                {/* <small className='recording-time'>Time Taken :  {timeTaken}, size : {fileSize}</small> */}
                {/* <small className='recording-time'>Time Taken To Upload :  {timeTaken}</small> */}
                <button onClick={handleContinueBtn} >Continue</button>
            </div>
        </div>
    );
}

export default ConsentStepperContainer;
